import { render, staticRenderFns } from "./Tema5.vue?vue&type=template&id=068b45b0&scoped=true&lang=pug&"
import script from "./Tema5.vue?vue&type=script&lang=js&"
export * from "./Tema5.vue?vue&type=script&lang=js&"
import style0 from "./Tema5.vue?vue&type=style&index=0&id=068b45b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b45b0",
  null
  
)

export default component.exports